import {
  CartProps
} from '@comicrelief/data-models/schemas/payments/models/Cart';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GtmEventChangeInterface {
  eventType: string | null,
  cartId: string | null,
  cartData: CartProps | null,
}

export const GTM_EVENTS = {
  FRONT_PAGE_LOAD: 'FRONT_PAGE_LOAD',
  FRONT_PAGE_CHANGE: 'FRONT_PAGE_CHANGE',
  GIFTAID_PAGE: 'GIFTAID_PAGE',
  // Since Payin has no Giftaid page, we need an equivalent:
  PAYIN_ACTIVITY_PAGE: 'PAYIN_ACTIVITY_PAGE',
  AFTER_PAYMENT_PAGE: 'AFTER_PAYMENT_PAGE',
};

// To allow us to easily store and use
// just what we need for our usecase
export interface PreviousUserChoiceObject {
  previousAmount: number,
  previousPosition: number | null,
  previousJourney: string
}

export interface GtmState {
  gtmInstantiated?: boolean,
  previousUserChoice: PreviousUserChoiceObject | null,
  currentPage?: string | null,
}

const initialState: Readonly<GtmState> = {
  gtmInstantiated: false,
  previousUserChoice: null,
  currentPage: null
};

export const gtmSlice = createSlice({
  name: 'gtm',
  initialState,
  reducers: {
    setGtmInstantiated(state: GtmState, action: PayloadAction<boolean>) {
      return {
        ...state,
        gtmInstantiated: action.payload,
      };
    },
    // Basic function call to allow gtmMiddleware listener to hook into it:
    setGtmEventChange(state: GtmState, action: PayloadAction<GtmEventChangeInterface>) {
      // Belt 'n' braces:
      return {
        ...state,
        ...(state.gtmInstantiated && { currentPage: action.payload.eventType }),
      };
    },
    setGtmPreviousUserChoice(state: GtmState, action: PayloadAction<PreviousUserChoiceObject | null>) {
      return {
        ...state,
        previousUserChoice: action.payload,
      };
    },
    // Should we need it:
    resetGtmState() {
      return {
        ...initialState
      };
    }
  },
});

export const {
  setGtmInstantiated,
  setGtmPreviousUserChoice,
  setGtmEventChange,
  resetGtmState
} = gtmSlice.actions;
